import React from 'react';
import { Link } from 'react-router-dom';

import { FreespinsApi } from '@atlas/core';
import { staticRoutes } from '@atlas/routing';
import { EmptyStateView, Label, Loader } from '@atlas/ui';

import useFreeSpins from 'src/hooks/useFreeSpins';

import FreeSpinCard from './FreeSpinCard';

export const {
  FreeSpinsStatus: { ACTIVATED, CANCELED, DISABLED, EXPIRED, USED },
} = FreespinsApi;

const FreeSpins = () => {
  const { freeSpins, loading } = useFreeSpins();

  if (loading) {
    return <Loader className="relative" />;
  }

  if (freeSpins.length === 0) {
    return (
      <EmptyStateView
        className="freespins-empty-state"
        description="freespins_empty_text"
        title="freespins_empty_title"
      >
        <Link className="btn primary medium" to={staticRoutes.casino}>
          <Label message="go_to_casino" />
        </Link>
      </EmptyStateView>
    );
  }

  return (
    <div className="freespins">
      {freeSpins.map(freeSpin => (
        <FreeSpinCard freeSpin={freeSpin} key={freeSpin.id} />
      ))}
    </div>
  );
};

export default FreeSpins;
